import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "relative z-50",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "fixed inset-0 z-10 flex items-center justify-center p-4" }
const _hoisted_3 = {
  class: "relative flex w-full max-w-md flex-col overflow-hidden rounded-lg bg-white shadow-xl",
  style: {"max-height":"80vh"}
}
const _hoisted_4 = { class: "flex items-center justify-between border-b border-greyLight px-4 py-3" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "flex-1 overflow-y-auto p-4",
  style: {"min-height":"0"}
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-10 text-grey"
}
const _hoisted_8 = { class: "mb-3 truncate text-sm text-grey" }
const _hoisted_9 = { class: "rounded-lg border-2 border-dashed border-greyLight bg-background p-2" }
const _hoisted_10 = {
  ref: "signatureCanvas",
  class: "signature-canvas"
}
const _hoisted_11 = { class: "mt-3 flex items-center justify-between text-xs text-grey text-opacity-50" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-10 text-grey"
}
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-10 text-center text-grey"
}
const _hoisted_15 = { class: "mt-1 text-xs text-grey text-opacity-50" }
const _hoisted_16 = {
  ref: "positionContainer",
  class: "relative"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "border-t border-greyLight px-4 py-3"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "flex space-x-3"
}
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    duration: 300
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "fixed inset-0 bg-gray-400 bg-opacity-75 transition-opacity",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "truncate pr-3 text-sm font-semibold text-grey" }, " Подпись документа ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-greyLight text-grey",
                disabled: _ctx.signing,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
              ]))], 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.signing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("div", { class: "h-8 w-8 animate-spin rounded-full border-b-2 border-[#FFD92E]" }, null, -1),
                    _createElementVNode("div", { class: "mt-3 text-sm text-grey text-opacity-50" }, "Накладываем подпись...", -1)
                  ]))]))
                : (_ctx.step === 'draw')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.document?.name), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("canvas", _hoisted_10, null, 512)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.hasSignature ? "Подпись готова" : "Нарисуйте подпись"), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "flex items-center space-x-1 text-red",
                          disabled: !_ctx.hasSignature,
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearSignature && _ctx.clearSignature(...args)))
                        }, [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("i", { class: "fas fa-eraser" }, null, -1),
                          _createElementVNode("span", null, "Очистить", -1)
                        ]))], 8, _hoisted_12)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-3 text-sm text-grey" }, " Кликните по документу в нужном месте, чтобы разместить подпись ", -1)),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("div", { class: "h-8 w-8 animate-spin rounded-full border-b-2 border-[#FFD92E]" }, null, -1),
                            _createElementVNode("div", { class: "mt-3 text-sm text-grey text-opacity-50" }, "Загружаем документ...", -1)
                          ]))]))
                        : (_ctx.error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-file-excel text-3xl text-red" }, null, -1)),
                              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mt-3 text-sm" }, "Не удалось открыть документ", -1)),
                              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.error), 1)
                            ]))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("canvas", {
                          ref: "pdfCanvas",
                          class: "cursor-crosshair block rounded-md bg-white shadow",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCanvasClick && _ctx.onCanvasClick(...args)))
                        }, null, 512),
                        (_ctx.placed)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.signatureDataUrl,
                              class: "pointer-events-none absolute",
                              style: _normalizeStyle(_ctx.signatureImageStyle)
                            }, null, 12, _hoisted_17))
                          : _createCommentVNode("", true)
                      ], 512)
                    ], 64))
            ]),
            (!_ctx.signing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.step === 'draw')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: _normalizeClass(["flex w-full items-center justify-center rounded-lg py-3 text-sm font-semibold transition", 
                _ctx.hasSignature
                  ? 'bg-blue text-white active:scale-95'
                  : 'bg-greyLight text-grey text-opacity-30'
              ]),
                        disabled: !_ctx.hasSignature,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
                      }, " Далее ", 10, _hoisted_19))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "flex items-center justify-center rounded-lg bg-greyLight px-6 py-3 text-sm font-semibold text-grey",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                        }, " Назад "),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["flex flex-1 items-center justify-center rounded-lg py-3 text-sm font-semibold transition", 
                  _ctx.placed
                    ? 'bg-blue text-white active:scale-95'
                    : 'bg-greyLight text-grey text-opacity-30'
                ]),
                          disabled: !_ctx.placed,
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSign && _ctx.onSign(...args)))
                        }, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1),
                          _createTextVNode(" Подписать ", -1)
                        ]))], 10, _hoisted_21)
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state]
      ])
    ]),
    _: 1
  }))
}